"use strict";

var _defineProperty = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _toConsumableArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DynamicMatrixQuestion;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Radio = require("@mui/material/Radio");
var _Radio2 = _interopRequireDefault(_Radio);
var _Button = require("@mui/material/Button");
var _Button2 = _interopRequireDefault(_Button);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _QuestionText = require("../QuestionText");
var _QuestionText2 = _interopRequireDefault(_QuestionText);
var _useQuestionAnswer = require("../../hooks/use-question-answer");
var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);
var _Dropdown = require("../DropdownQuestion/Dropdown");
var _Dropdown2 = _interopRequireDefault(_Dropdown);
var _Checkbox = require("@mui/material/Checkbox");
var _Checkbox2 = _interopRequireDefault(_Checkbox);
var _Delete = require("@mui/icons-material/Delete");
var _Delete2 = _interopRequireDefault(_Delete);
var _TextField = require("@mui/material/TextField");
var _TextField2 = _interopRequireDefault(_TextField);
var _AsyncDropdown = require("../AsyncDropdown");
var _AsyncDropdown2 = _interopRequireDefault(_AsyncDropdown);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Row = _styledComponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 10px;\n"])));
var Col = _styledComponents2.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  && {\n    font-family: Roboto, sans-serif;\n    flex: 1;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n"])));
var HeaderCol = (0, _styledComponents2.default)(Col)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  padding-right: 10px;\n"])));
var LastCol = (0, _styledComponents2.default)(Col)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  && {\n    margin-left: 4px;\n    width: 100px;\n    flex: 0;\n  }\n"])));
var CheckboxButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  && {\n    align-items: center;\n    padding-left: 12px;\n    padding-right: 12px;\n    margin-left: 2px;\n    margin-right: 2px;\n  }\n  .checkbox {\n    padding-left: 0;\n    padding-top: 4px;\n    padding-bottom: 4px;\n  }\n  .text {\n    text-transform: none;\n  }\n"])));
function DynamicMatrixQuestion(_ref) {
  var question = _ref.question,
    autocompleteRequest = _ref.autocompleteRequest,
    onChangeAnswer = _ref.onChangeAnswer,
    _ref$defaultAnswer = _ref.defaultAnswer,
    defaultAnswer = _ref$defaultAnswer === void 0 ? [] : _ref$defaultAnswer;
  var _ref2 = (0, _useQuestionAnswer2.default)(question, onChangeAnswer, defaultAnswer),
    _ref3 = _slicedToArray(_ref2, 2),
    _ref3$ = _ref3[0],
    answer = _ref3$.answer,
    error = _ref3$.error,
    changeAnswer = _ref3[1];
  var answerWithBlank = answer.concat([{}]);
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer.length > 0
  }, _react2.default.createElement(Row, null, question.columns.map(function (_ref4) {
    var title = _ref4.title,
      name = _ref4.name;
    return _react2.default.createElement(HeaderCol, {
      style: {
        fontSize: question.columns.length > 3 ? 12 : undefined
      },
      key: name
    }, title || name);
  }), _react2.default.createElement(LastCol, null, _react2.default.createElement(_Button2.default, {
    tabIndex: -1,
    style: {
      opacity: 0
    },
    disabled: true
  }, _react2.default.createElement(_Delete2.default, null)))), answerWithBlank.map(function (a, i) {
    return _react2.default.createElement(Row, {
      key: i
    }, question.columns.map(function (_ref5) {
      var name = _ref5.name,
        cellType = _ref5.cellType,
        _ref5$choices = _ref5.choices,
        choices = _ref5$choices === void 0 ? question.choices : _ref5$choices,
        requestUrl = _ref5.requestUrl;
      var changeRowAnswer = function changeRowAnswer(newAnswer) {
        changeAnswer([].concat(_toConsumableArray(answer.slice(0, i)), [_objectSpread(_objectSpread({}, a), {}, _defineProperty({}, name, newAnswer))], _toConsumableArray(answer.slice(i + 1))));
      };
      var rowAnswer = answerWithBlank[i][name];
      return _react2.default.createElement(Col, {
        key: name
      }, cellType === "dropdown" ? _react2.default.createElement("div", {
        style: {
          paddingRight: 4
        }
      }, _react2.default.createElement(_Dropdown2.default, {
        answer: answerWithBlank[i][name],
        choices: choices,
        changeAnswer: function changeAnswer(newAnswer) {
          return changeRowAnswer(newAnswer);
        },
        id: question.id ? question.id + "Dropdown" : ""
      })) : cellType === "autocomplete" ? _react2.default.createElement("div", {
        style: {
          paddingRight: 4
        }
      }, _react2.default.createElement(_AsyncDropdown2.default, {
        key: rowAnswer,
        answer: rowAnswer,
        requestUrl: requestUrl,
        autocompleteRequest: autocompleteRequest,
        onChange: changeRowAnswer,
        id: question.id ? question.id + "DropDown" : ""
      })) : cellType === "checkbox" ? _react2.default.createElement("div", null, choices.map(function (choiceRaw, choiceIndex) {
        var choice = typeof choiceRaw === "string" ? {
          value: choiceRaw,
          text: choiceRaw
        } : choiceRaw;
        return _react2.default.createElement(CheckboxButton, {
          key: choiceIndex,
          onClick: function onClick() {
            return changeRowAnswer((rowAnswer || []).includes(choice.value) ? rowAnswer.filter(function (r) {
              return r !== choice.value;
            }) : (rowAnswer || []).concat([choice.value]));
          }
        }, _react2.default.createElement(_Checkbox2.default, {
          tabIndex: -1,
          className: "checkbox",
          checked: (rowAnswer || []).includes(choice.value),
          id: question.id ? question.id + choice.text : ""
        }), _react2.default.createElement("div", {
          className: "text"
        }, choice.text));
      })) : cellType === "text" ? _react2.default.createElement("div", {
        style: {
          paddingRight: 4
        }
      }, _react2.default.createElement(_TextField2.default, {
        value: rowAnswer || "",
        onChange: function onChange(e) {
          return changeRowAnswer(e.target.value);
        },
        id: question.id ? question.id + "Text" : ""
      })) : "Unknown Cell Type \"".concat(cellType, "\""));
    }), _react2.default.createElement(LastCol, null, _react2.default.createElement(_Button2.default, {
      tabIndex: -1,
      style: {
        alignSelf: "center"
      },
      disabled: i === answerWithBlank.length - 1,
      onClick: function onClick() {
        return changeAnswer([].concat(_toConsumableArray(answer.slice(0, i)), _toConsumableArray(answer.slice(i + 1))));
      },
      id: question.id ? question.id + "Button" : ""
    }, _react2.default.createElement(_Delete2.default, null))));
  }));
}